module.exports = __webpack_public_path__ + "6490cbc8d212f189ea20948b9bd8d3a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shop_bg2.jpg
// module id = 205
// module chunks = 1